import React, { useState } from 'react';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import fileDownload from 'js-file-download';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import Loader from '../../../components/base/Loader/Loader';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import {
  loadFileByUrl, showGlobalConfirm, showSignPopup, signDocument,
} from '../actions';
import {

  deleteDocument,

  generateDocx,
  unAssignApplicationById,
} from '../../Application/actions';
import { errorNotification, successNotification } from '../../Notifications/notificationDecorator';
import { getResponseError, nameBySave, responseLogWithNotification } from '../../../utils/utils';
import { dateFormatter } from '../../../utils/formatters';

export default function ViewDocument(props) {
  const {
    document = {},
    loadingSignDocument = false,
    isDownloadAvailable = true,
    isSignAvailable = false,
    prevCrumbs = null,
    handleClose = () => {},
    loadData = () => {},
    loadById = () => {},
    loadingCurrentApplication = false,
    loadingReturnApplication = false,
    loadingDeniedApplication = false,
    loadingSuspendedApplication = false,
  } = props;
  const dispatch = useDispatch();
  const {
    files, is_actual, status, notification_template,
  } = document;
  const signedFile = files.find(f => f.collection_name === 'signed');
  const unsignedFile = files.find(f => f.collection_name === 'unsigned');
  const signatureFile = files.find(f => f.collection_name === 'signature');
  const isLoading = loadingSignDocument;
  const file = signedFile || unsignedFile;
  const [modal, setModal] = useState(false);
  const application = document && document.context && document.context.application ? document.context.application : null;

  const unAssign = id => dispatch(unAssignApplicationById(id))
    .catch(response => {
      errorNotification('Загрузка заявления', getResponseError(response));
    });

  const afterSetEndStatus = () => {
    unAssign(application?.id).then(() => {
      loadData();
    });
  };

  const handleDownload = () => {
    dispatch(loadFileByUrl(file.url))
      .then(data => {
        if (data) {
          const templateName = document && document.notification_template && document.notification_template.name
            ? document.notification_template.name
            : document.id;
          const name = nameBySave(`${templateName} № ${document.number} от ${dateFormatter(document.created_at)}.pdf`);
          fileDownload(data, file.file_name || name);
        }
      })
      .catch(responseLogWithNotification);
  };

  const handleDownloadSig = () => {
    dispatch(loadFileByUrl(signatureFile.url))
      .then(data => {
        if (data) {
          fileDownload(data, signatureFile.file_name);
        }
      })
      .catch(responseLogWithNotification);
  };

  const handleDownloadDocx = () => {
    dispatch(generateDocx(document.id))
      .then(data => {
        if (data) {
          const templateName = document && document.notification_template && document.notification_template.name;
          const name = `${templateName || document.type_label} ${document.number}.docx`;
          fileDownload(data, name);
        }
      })
      .catch(responseLogWithNotification);
  };
  const handleDelete = () => {
    dispatch(showGlobalConfirm({
      confirmMessage: `Удаление документа №${document.name}`,
      confirmButtonText: 'Удалить',
      confirmClassName: 'remove-preset',
    })).then(() => {
      dispatch(deleteDocument(document.id)).then(() => {
        loadData();
        handleClose();
        successNotification('Удаление документа', 'Удаление прошло успешно');
      }).catch(response => {
        errorNotification('Удаление документа', getResponseError(response));
      });
    }).catch(() => {});
  };
  const handleSign = () => {
    dispatch(showSignPopup()).then(cert => {
      dispatch(signDocument({ cert, document }))
        .then(() => {
          successNotification('Подписание документа', 'Подписание прошло успешно');
          loadData();
          loadById(document.id);
        })
        .catch(error => {
          errorNotification('Подписание документа', error || 'Ошибка подписания файла');
        });
    }).catch(() => {});
  };

  return (
    <Dialog
      onClose={handleClose}
      open
      className={classNames('file-viewer')}
      size="xl"
    >
      <DialogTitle
        header={(
          <div className="file-viewer-header">
            <div className="application-form-header">
              <div className="breadcrumbs">
                {prevCrumbs || null}
                <span className="breadcrumbs-current">
                  {document?.name || document?.notification_template?.name || 'Просмотр документа'} № {document?.number || 'Без номера'}
                </span>
              </div>
            </div>
            {signedFile
              ? (
                <div className="file-viewer-header-icon-wrapper">
                  <Icons customIcon icon="pencil" className="file-viewer-header-icon" />
                </div>
              )
              : null}
          </div>
            )}
        title={<Icons onClick={handleClose} customIcon icon="close" className="close" />}
      />
      <DialogContent>
        <Loader loading={isLoading} />
        {file && file.url ? <iframe title="Просмотр файла" src={file.url} frameBorder="0" width="100%" height="100%" /> : null}
        {!file || !file.url ? <div className="file-not-found">Файл не найден</div> : null}
      </DialogContent>
      <DialogFooter className="modal-buttons">
        {isDownloadAvailable ? (
          <Button
            variant="secondary"
            className="download-button"
            onClick={handleDownloadDocx}
          >
            <Icons customIcon className="file-download" width={24} height={24} icon="download" />
            <span className="download-button-text">Docx</span>
          </Button>
        ) : null}
        {isDownloadAvailable ? (
          <Button
            variant="secondary"
            className="download-button"
            onClick={handleDownload}
          >
            <Icons customIcon className="file-download" width={24} height={24} icon="download" />
            <span className="download-button-text">Pdf</span>
          </Button>
        ) : null}
        {isDownloadAvailable && signedFile ? (
          <Button
            variant="secondary"
            className="download-button"
            onClick={handleDownloadSig}
          >
            <Icons customIcon className="file-download" width={24} height={24} icon="download" />
            <span className="download-button-text">Sig</span>
          </Button>
        ) : null}
        <div className="ms-auto" />
        <Loader loading={loadingCurrentApplication || loadingReturnApplication || loadingDeniedApplication || loadingSuspendedApplication} />
      </DialogFooter>
    </Dialog>
  );
}
